import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import SideBar from '../../components/sidebar';
import moment from "moment";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { costAgree, isAutoPay } from "../../services/patient/action";
import $ from 'jquery';
import { footer } from "../../components/footerSize";


class FinalRequest extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            recordsTypeRequested: [],
            iConfirm: false,
            costAgree: false,
            totalCostNeedtoWatch: false,
            authorize: false,
            UserName: "",
            userType: "",
            iAgree: false,
            expirationValue: "",
            thirdPartyClassValue: "",
            requestedDate: "",
            startDate: "",
            endDate: "",
            efaxValue: "",
            fedexValue: "",
            responseValue: "",
            otherText: "",
            todos: [],
            thirdPartyRequestId:""
        }
    }

    componentDidMount() {
        // onDocumentReady function bind
        $(document).ready(function () {
            footer("#content");
        });

        // onResize bind of the function
        $(window).resize(function () {
            footer("#content");
        });

        let one = this.props.profileDetails.commonUser.firstName;
        let two = this.props.profileDetails.commonUser.lastName;
        let userType = this.props.profileDetails.commonUser.userType;

        let UserName = one + " " + two
        this.setState({
            UserName,
            userType
        })
        let data = this.props.getApiCostDetails
        let requestData = this.props.requestDetailsforFinalRequest;
        let recordDetails = this.props.recordDetails;
         if (data.approximateCostDTO) {
             let recordsTypeRequested = data.approximateCostDTO.recordsTypeRequested;
            recordsTypeRequested.filter((record) => {
                if (record.id == 13) {
                    let index = recordsTypeRequested.indexOf(record);
                    recordsTypeRequested.splice(index, 1);
                }
            })
            this.setState({
                recordsTypeRequested
            })
            this.appendModel(recordDetails)
        }
    }
    appendModel = (record) => {
         let expirationValue = record.expirationValue ? record.expirationValue : "";
        let thirdPartyClassValue = record.thirdPartyClassValue ? record.thirdPartyClassValue : "";
        let thirdPartyRequestId = record.thirdPartyRequestId ? record.thirdPartyRequestId : "";
        let requestedDate = record.requestedDate ? record.requestedDate : "";
        let startDate = record.startDate ? record.startDate : "";
        let endDate = record.endDate ? record.endDate : "";
        let efaxValue = record.efaxValue ? record.efaxValue : "";
        let fedexValue = record.fedexValue ? record.fedexValue : "";
        let responseValue = record.responseValue ? record.responseValue : "";
        let otherText = record.otherText ? record.otherText : "";
        let todos = record.todos ? record.todos : [];

        startDate = moment(startDate).format("MM-DD-YYYY");
        endDate = moment(endDate).format("MM-DD-YYYY");
        this.setState({

            expirationValue,
            thirdPartyClassValue,
            thirdPartyRequestId,
            requestedDate,
            startDate,
            endDate,
            efaxValue,
            fedexValue,
            responseValue,
            otherText,
            todos

        })
    }
    confirmDetails = () => {
        this.setState(
            { iConfirm: !this.state.iConfirm })

    };

    costAgree = () => {
        this.setState(
            { iAgree: !this.state.iAgree, totalCostNeedtoWatch: false });
    }

    costNotAgree = () => {
        this.setState(
            { totalCostNeedtoWatch: !this.state.totalCostNeedtoWatch, iAgree: false });
    }

    navNext = () => {
        this.props.history.push("/Paymentpage")
    }

    Iauthorize = () => {
        this.setState({
            authorize: !this.state.authorize
        })
    }


    finalRequest = () => {
        let data = this.props.requestDetailsforFinalRequest
        let payload = {
            recordsTypeDTO: data.recordsTypeDTO,
            facilityInfoId: data.facilityInfoId,
            recordStatusId: data.recordStatusId,
            userInfoId: data.userInfoId,
            responseTimeId: data.responseTimeId,
            requestTypId: data.requestTypId,
            requestStatusId: data.requestStatusId,
            expirationId: data.expirationId,
            fromDate: data.fromDate,
            toDate: data.toDate,
            faxNo: data.faxNo,
            requestToAddress: data.requestToAddress,
            thirdPartyRequestId : data.thirdPartyRequestId
        }

        let thirdPartyClassId = this.props.id ? this.props.id : ""
        let thirdPartyPatientNames = this.props.list ? this.props.list : []

        var formData = new FormData();
        formData.append('requestDTO', JSON.stringify(payload));
        formData.append('multipartFile', data.uploadDocument);
        formData.append('thirdPartyClassId', thirdPartyClassId);
        formData.append('thirdPartyPatientNames', JSON.stringify(thirdPartyPatientNames));
        formData.append('isAutoPay', false);

        let token = this.props.loginDetails;

        this.props.isAutoPay(token, formData);
    }


    // costAgreeService = () => {
    //     let data = this.props.getApiCostDetails.approximateCostDTO.RequestId;
    //     let checkValue = this.state.cost

    //     var formData = new FormData();
    //     formData.append('requestInfoId', data);
    //     formData.append('costAgreed', checkValue);

    //     let token = this.props.loginDetails;

    //     this.props.costAgree(token, formData, )

    // }

    componentWillReceiveProps = nextProps => {
        if (nextProps.isAutoPayStatus) {
            this.props.history.push("/RequestStatus")
        }
    }




    render() {


        const {
            expirationValue,
            thirdPartyClassValue,
            requestedDate,
            startDate,
            endDate,
            efaxValue,
            fedexValue,
            responseValue,
            otherText, todos,thirdPartyRequestId
        } = this.state

        

        let approximateCost = "";
        let faddress = "";
        let faddress2 = "";
        let fcity = "";
        let ffacilityName = "";
        let fstate = "";
        let fzip = "";
        let paddress = "";
        let paddress2 = "";
        let pcity = "";
        let pstate = "";
        let pName = "";
        let pzip = "";
        let data = "";
        let faciState = ""
        if (this.props.getFacilityAddress) {
            faciState = this.props.getFacilityAddress.facilityAddressDTO.state;
        }
        if (this.props.getApiCostDetails) {

            data = this.props.getApiCostDetails.approximateCostDTO;
            approximateCost = data.approximateCost;
            if (data.RequestedMode.includes("fedex")) {
                let fromAddress = data.fromAddress;
                let toAdd = data.toAddress
                faddress = fromAddress.address;
                faddress2 = fromAddress.address2;
                fcity = fromAddress.city;
                ffacilityName = fromAddress.facilityName;
                fstate = fromAddress.state;
                fzip = fromAddress.zip;
                paddress = toAdd.address;
                paddress2 = toAdd.address2;
                pcity = toAdd.city;
                pstate = toAdd.state;
                pzip = toAdd.zip;
            }

        }
        if (this.props.profileDetails.commonUser) {
            let data = this.props.profileDetails.commonUser
            pName = (data.firstName && data.firstName)
        }


        return (
            <>


                <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/PatientHome", }, { "name": "Select a Practice/Doctor", "route": "/PatientRequest", }, { "name": "Select Record", "route": "/PatientRecord", }, { "name": "Confirm Details", "route": "/FinalRequest" }]} />

                <div className="content">
                    <div className="contentSection" id="content">
                        <div className="container-fluid">

                            <div className="bodyContent">
                                <h3 className="title-text">Step 3 : Confirming Details</h3>





                                <div className="row mt-3">
                                    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 ">
                                        <div className="sec-head pull-right">
                                            <label>Approximate Cost</label>
                                        </div>



                                    </div>
                                    <div className="col-lg-9 col-md-6 col-sm-6 col-xs-12 ">
                                        <div className="sec-head">
                                            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12"> <input type="text" readOnly value={"$ " + approximateCost} className="form-control" /></div>
                                            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">  <label style={{ fontSize: "12px", fontWeight: "600" }}>Exact cost will be determined once the record is retrieved and the page count is confirmed. The cost of medical records retrieval is determined by the laws of {faciState}.
                        <ol className="est-ol">

                                                </ol></label></div>

                                        </div>



                                    </div>

                                </div>
                                <div className="row ">
                                    <div className="col-lg-12 col-md-12">
                                        <input className="inp-cbx" id="bx" onChange={this.costAgree} checked={this.state.iAgree} type="checkbox" style={{ display: "none" }} />
                                        <label className="cbx" htmlFor="bx"><span>
                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                            </svg></span><span className="check-lab">I need my records and will pay regardless of the correctly calculated cost</span></label>
                                    </div></div>

                                <div className="row ">
                                    <div className="col-lg-12 col-md-12">
                                        <input className="inp-cbx" id="cbx" onChange={this.costNotAgree} checked={this.state.totalCostNeedtoWatch} type="checkbox" style={{ display: "none" }} />
                                        <label className="cbx" htmlFor="cbx"><span>
                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                            </svg></span><span className="check-lab">I would like to see the total cost before committing to pay</span></label>
                                    </div>
                                </div>
                                {this.state.userType === "patient" &&
                                    <>
                                        <h5 class="card-page-note">I understand I may revoke this authorization at any time. I understand that if I revoke this authorization I must do so in writing and present my written revocation
                                to Ferndale Road, LLC by emailing <a href="mailto:revocation@ferndaleroad.com">revocation@ferndaleroad.com</a>. I understand that the revocation will not
                                                        apply to information that has already been released in response to this authorization. I understand that the revocation will not apply to my insurance company when the law provides
                                                         my insurer with the right to contest a claim under my policy or when my insurance company has the right to otherwise retrieve my medical records without additional consent. Unless otherwise
                                                         revoked or allowed by me, this authorization will expire thirty (30) days after this records request. I understand that authorizing the disclosure of this health information is voluntary.
                                                         I need not authorize the release of my medical records to assure treatment from the disclosing facility. I understand that I may inspect or obtain a copy of the information to be used or disclosed, as provided
                                                         in CFR 164.524. I understand that any disclosure of information carries with it the potential for an unauthorized redisclosure and the information may not be protected by federal confidentiality rules
                                </h5>
                                    </>}




                                <div className="row mt-3">
                                    {(data.RequestedMode.includes("fedex")) &&
                                        <>

                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 ">
                                                <div className="sec-head">
                                                    <h4>Records Going To</h4>
                                                </div>
                                                <div className="check-sec">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <p>
                                                                {pName}<br />
                                                                {paddress},<br />
                                                                {paddress2},<br />
                                                                {pcity},{pstate} {pzip}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </>
                                    }
                                    <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12 ">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">

                                                <div className="sec-head">
                                                    <h4>Request Summary</h4>
                                                </div>
                                                <div className="check-sec">
                                                    <div>
                                                        <label class="fw600 title-model-color">Requested Records Details</label></div>
                                                    <ol>
                                                        {this.state.recordsTypeRequested.length > 0 ?
                                                            this.state.recordsTypeRequested.map((record, id) => {
                                                                return (
                                                                    <li key={id}>{record.type}</li>

                                                                )
                                                            }) : "No records selected"
                                                        }

                                                    </ol>
                                                    {otherText !== "" &&
                                                        <>
                                                            <label class="fw600 title-model-color">Other Record Details</label>
                                                            <div>{otherText}</div>
                                                        </>
                                                    }

                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ marginTop: "20px" }}>
                                                <div className="check-sec">

                                                    <table class="modal-table-design">
                                                        <tr>


                                                            <>
                                                                <td class="model-td-design">
                                                                    <label class="fw600 title-model-color">Authorization Expiration:</label></td>
                                                                <td class="model-td-design">
                                                                    <label>{expirationValue} </label>  </td>
                                                            </>



                                                        </tr>
                                                        <tr>
                                                            <td class="model-td-design">
                                                                <>

                                                                    <label class="fw600 title-model-color">Record Period Time:</label>
                                                                    <table class="table-200">
                                                                        <tr>
                                                                            {startDate != "Invalid date" &&
                                                                                <>
                                                                                    <td><label class="fw600">Start Date:</label></td>
                                                                                    <td>{startDate}</td>
                                                                                </>
                                                                            }
                                                                        </tr>
                                                                        <tr>
                                                                            {endDate != "Invalid date" &&
                                                                                <>
                                                                                    <td><label class="fw600">End Date:</label></td>
                                                                                    <td>{endDate}</td>
                                                                                </>
                                                                            }
                                                                        </tr>
                                                                        <tr>
                                                                            {requestedDate !== "" &&
                                                                                <>
                                                                                    <td><label class="fw600">Requested Date:</label></td>
                                                                                    <td>{requestedDate + "s"}</td>
                                                                                </>
                                                                            }


                                                                        </tr>

                                                                    </table>
                                                                </>

                                                            </td>
                                                        </tr>
                                                        <tr>


                                                            <td class="model-td-design">
                                                                <label class="fw600 title-model-color">Preferred Response Time:</label></td>
                                                            <td class="model-td-design">
                                                                <label> {responseValue}</label>  </td>


                                                        </tr>
                                                        <tr>
                                                            <td class="model-td-design">

                                                                <label class="fw600 title-model-color">Preferred delivery Mode:</label>

                                                            </td>
                                                            <td class="model-td-design">
                                                                <label> {efaxValue ? efaxValue + "," : ""} {fedexValue ? fedexValue + "," : ""} Download</label>  </td>
                                                        </tr>


                                                        {thirdPartyClassValue &&
                                                            <>
                                                                <tr>
                                                                    <td class="model-td-design">
                                                                        <label class="fw600 title-model-color">ThirdParty class type</label></td>
                                                                    <td class="model-td-design">
                                                                        <label>{thirdPartyClassValue}</label>  </td>
                                                                </tr>
                                                                 <tr>
                                                                    <td class="model-td-design">
                                                                        <label class="fw600 title-model-color">Third Party Request Id</label></td>
                                                                    <td class="model-td-design">
                                                                        <label>{thirdPartyRequestId}</label>  </td>
                                                                </tr>
                                                                {thirdPartyClassValue === "HEDIS" &&
                                                                    <tr>
                                                                        <td class="model-td-design">
                                                                            <label class="fw600 title-model-color">Patient names added</label></td>
                                                                        <td class="model-td-design">
                                                                            <ol>
                                                                                {this.state.todos.length > 0 ?
                                                                                    this.state.todos.map((item, id) => {
                                                                                        return (
                                                                                            <li key={id}>{item.patientNames}</li>

                                                                                        )
                                                                                    }) : "No records selected"
                                                                                }

                                                                            </ol>
                                                                        </td>
                                                                    </tr>


                                                                }

                                                            </>
                                                        }


                                                    </table></div>
                                                {/* <label>Authorization Expiration:{expirationValue}</label>
                                                    <label>Record PeriodTime:</label>
                                                          {" " +startDate} 
                                                          {"-" +endDate} 
                                                          {requestedDate}
                                                    <label>Preferred Response Time:{responseValue}</label>
                                                    <label>Preferred deliveryMode:{efaxValue}{fedexValue}</label>
                                                    {thirdPartyClassValue &&
                                                     <label>ThirdParty class{thirdPartyClassValue}</label>
                                                    } */}

                                            </div>
                                        </div>




                                    </div>
                                </div>



                                <div className="row mt-3 mb-2 ">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="row ">
                                            <div class="col-lg-12 col-md-12">
                                                <input className="inp-cbx" id="abc" onChange={this.confirmDetails} type="checkbox" style={{ display: "none" }} />
                                                <label className="cbx" htmlFor="abc"><span>
                                                    <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                    </svg></span><span className="check-lab">I confirm the above details are correct</span></label>
                                            </div></div>
                                        {this.state.userType === "patient" &&
                                            <>
                                                <div className="row mt-2 ">
                                                    <div class="col-lg-12 col-md-12">
                                                        <input className="inp-cbx" id="cax" onChange={this.Iauthorize} type="checkbox" style={{ display: "none" }} />
                                                        <label className="cbx" htmlFor="cax"><span>
                                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                            </svg></span><span className="check-lab">I, {this.state.UserName} have read the above Authorization for Release of Information and do hereby acknowledge that I am familiar with and fully understand the terms of this authorization

</span></label>
                                                    </div></div>
                                            </>}

                                        <div className="row mt-3 mb-2 text-center ">
                                            <NavLink to="/PatientRecord"> <button type="button" className="btnDefault">Back</button></NavLink>
                                            {this.state.userType === "patient" &&
                                                <>
                                                    {this.state.totalCostNeedtoWatch &&

                                                        <button disabled={!this.state.iConfirm || !this.state.authorize} type="button" onClick={this.finalRequest} className="btnDefault">Finalize Request</button>
                                                    }
                                                    {this.state.iAgree &&
                                                        <button disabled={!this.state.iConfirm || !this.state.authorize} type="button" onClick={this.navNext} className="btnDefault">Proceed to Payment</button>
                                                    }
                                                </>
                                            }
                                            {this.state.userType === "other" &&
                                                <>
                                                    {this.state.totalCostNeedtoWatch &&

                                                        <button disabled={!this.state.iConfirm} type="button" onClick={this.finalRequest} className="btnDefault">Finalize Request</button>
                                                    }
                                                    {this.state.iAgree &&
                                                        <button disabled={!this.state.iConfirm} type="button" onClick={this.navNext} className="btnDefault">Proceed to Payment</button>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></div>
                <Footer />

            </>
        )
    }
}


const mapStateToProps = state => ({

    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    message: state.patientReducer.message,
    getApiCostDetails: state.patientReducer.getApiCostDetails,
    requestDetailsforFinalRequest: state.patientReducer.requestDetailsforFinalRequest,
    recordDetails: state.patientReducer.recordDetails,
    isCostAgree: state.patientReducer.isCostAgree,
    getFacilityAddress: state.patientReducer.getFacilityAddress,
    list: state.patientReducer.list,
    id: state.patientReducer.id,
    isAutoPayStatus: state.patientReducer.isAutoPayStatus,


});

const mapDispatchToProps = dispatch => ({
    costAgree: (token, formData, ) => dispatch(costAgree(token, formData)),
    isAutoPay: (token, payload, ) => dispatch(isAutoPay(token, payload)),


});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinalRequest); 